/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * CameraIcon
 */
export default class CameraIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M12.93 3a3 3 0 012.496 1.336l.812 1.219A1 1 0 0017.07 6H20a3 3 0 013 3v9a3 3 0 01-3 3H4a3 3 0 01-3-3V9a3 3 0 013-3h1.264a1 1 0 00.894-.553l.395-.789A3 3 0 019.236 3zm0 2H9.236a1 1 0 00-.894.553l-.395.789A3 3 0 015.264 8H4a1 1 0 00-1 1v9a1 1 0 001 1h16a1 1 0 001-1V9a1 1 0 00-1-1h-2.93a3 3 0 01-2.496-1.336l-.812-1.219A1 1 0 0012.93 5zM12 9a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

